import React from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';
import { DesktopWindowsOutlined, SendOutlined, VpnKeyOutlined } from '@mui/icons-material';

export default function LicenseDeliveryGuide() {
  const steps = [
    { title: 'Prepara la licenza', description: 'Cliente, software, scadenza e postazioni.', icon: <VpnKeyOutlined /> },
    { title: 'Consegna codice o file', description: 'Per NextCut, NextFrame, NextDrill e NEXT Manager usa “Consegna licenza” nella riga.', icon: <SendOutlined /> },
    { title: 'Il cliente attiva il PC', description: 'Importa il file nel programma: il server verifica i diritti.', icon: <DesktopWindowsOutlined /> },
  ];
  return <Paper component="section" aria-label="Come consegnare le licenze software" sx={{ p: { xs: 2, md: 2.5 }, borderRadius: '14px' }}>
    <Stack direction={{ xs: 'column', md: 'row' }} spacing={2.5}>
      {steps.map((step, index) => <Stack key={step.title} direction="row" spacing={1.5} sx={{ flex: 1, minWidth: 0 }}>
        <Box sx={{ width: 38, height: 38, flexShrink: 0, borderRadius: 2, bgcolor: 'action.hover', display: 'grid', placeItems: 'center', color: 'primary.main' }}>{step.icon}</Box>
        <Box><Typography variant="body2" fontWeight={700}>{index + 1}. {step.title}</Typography><Typography variant="caption" color="text.secondary">{step.description}</Typography></Box>
      </Stack>)}
    </Stack>
  </Paper>;
}
